// extracted by mini-css-extract-plugin
module.exports = {"item":"AccordionTextItem_item__adF2E","trigger":"AccordionTextItem_trigger__CiZ_J","content":"AccordionTextItem_content__G0vl3"};